import { useSelector } from "react-redux";

export default function Corner({ enabled = true }) {
  const theme = useSelector((state) => state.element.theme);
  const borderColor = enabled
    ? `border-${theme}-radio`
    : `border-${theme}-corner-disabled`;
  return (
    <>
      <span className={`corner-t-l ${borderColor}`} aria-hidden="true" />
      <span className={`corner-t-r ${borderColor}`} aria-hidden="true" />
      <span className={`corner-b-r-select ${borderColor}`} aria-hidden="true" />
      <span className={`corner-b-l-select ${borderColor}`} aria-hidden="true" />
    </>
  );
}
